// extracted by mini-css-extract-plugin
export default {"container":"IconPicker_container__AZnSD"};